import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {SelectionItem} from '../../selections/selection-item';
import {SelectionService} from '../../services/selection-service';
import {ScheduleSharingInput} from '../../model/schedule-sharing-input';
import { HttpErrorResponse } from '@angular/common/http';
import {StringUtils} from '../../utils/string-utils';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';


@Component({
    selector: 'app-schedule-sharing-dialog',
    templateUrl: './schedule-sharing-dialog.component.html',
    styleUrls: ['./schedule-sharing-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatButton]
})
export class ScheduleSharingDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<ScheduleSharingDialogComponent>>(MatDialogRef);
  private readonly dialog = inject(MatDialog);
  private readonly selectionService = inject(SelectionService);
  private readonly data = inject(MAT_DIALOG_DATA);


  private readonly user: string;
  private readonly scheduleId: string;
  readonly officeLabel: string;
  readonly userLabel: string;
  readonly notificationLabel: string;
  organizations: SelectionItem[];
  readonly notificationUsers = signal<SelectionItem[]>(undefined!);
  input!: ScheduleSharingInput;
  readonly isBusy = signal<boolean>(undefined!);
  readonly errorMessage = signal<string>(undefined!);

  constructor() {
    const data = this.data;

    this.user = data.user;
    this.scheduleId = data.scheduleId;
    this.organizations = data.organizations;
    this.officeLabel = data.officeLabel;
    this.userLabel = data.userLabel;
    this.notificationLabel = data.notificationLabel;
  }

  ngOnInit(): void {
    this.input = new ScheduleSharingInput();
    this.input.scheduleId = this.scheduleId;
    this.input.user = this.user;
    if ((this.organizations?.length || 0) === 1) {
      this.input.organizationId = this.organizations[0].code;
    }
    this.loadOrganizationUsers();
    if (this.canSave()) {
      this.save();
    }
  }

  save(): void {
    if (this.canSave()) {
      this.dialogRef.close(this.input);
    }
  }

  canSave(): boolean {
    return !StringUtils.isBlank(this.input?.scheduleId) && !StringUtils.isBlank(this.input?.user)
      && !StringUtils.isBlank(this.input?.organizationId) && !StringUtils.isBlank(this.input?.notificationUser);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  loadOrganizationUsers(): void {
    this.errorMessage.set(undefined!);
    this.notificationUsers.set([]);
    this.input.notificationUser = undefined!;
    if ((this.input?.organizationId?.trim()?.length || 0) > 0) {
      this.isBusy.set(true);
      this.selectionService.getOrganizationActiveUsers(this.input.organizationId).subscribe({
        next: (users) => {
          this.notificationUsers.set(users);
          if ((users?.length || 0) === 1) {
            this.input.notificationUser = users[0].code;
          }
          this.isBusy.set(false);
        }, error: (error) => this.handleError(error)
      });
    }
  }

  private handleError(error: HttpErrorResponse): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

}
